import useNavigation from '../../../../hook/useNavigation';
import useScroll from '../../../../hook/useScroll';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { UFOODX_BASE_URL } from '../../../../utils/constants';
import { isEmptyData } from '../../../../utils/helper';

const Back = (props) => {
	const { className, route } = props;
	const navigate = useNavigation();
	const { isScrolled } = useScroll();

	const handleBack = () => {
    if (!isEmptyData(route)) {
      route?.()
      return;
    }
		const referrer = document.referrer;
		let previousPath = '';

		if (referrer) {
			try {
				const url = new URL(referrer);
				previousPath = url.pathname;
			} catch (e) {
				previousPath = '';
			}
		}

		if (!referrer || previousPath === '/' || window.history.length <= 1) {
			navigate.push(`${UFOODX_BASE_URL}`);
			return;
		}

		navigate.back();
	};

  const iconClass = `
    text-gray-900 transition-all duration-300 shadow-none bg-transparent
    ${isScrolled ? 'h-5 w-5 mr-1' : 'bg-white rounded-full p-1 h-7 w-7'}
    ${className || ''}
  `;

	return (
		<div className='flex justify-center items-center cursor-pointer' onClick={() => handleBack()} id='merchant_back'>
			<ArrowLeftIcon className={iconClass} />
		</div>
	);
};

export default Back;
